import React, { useState } from "react";
import { useLocation, useNavigate, useSearchParams, Link } from "react-router-dom";
import useVerifyOtp from "../../hooks/useVerifyOtp";
import useForgotPassword from "../../hooks/useForgotPassword";
import OTPInput from "../../components/OTPInput";
import SafeImage from "../../components/common/SafeImage";

export default function Otp() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Try to get phone_no from location state or search param
  const phone_no =
    location.state?.phone_no || searchParams.get("phone_no") || "";
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const verifyOtpMutation = useVerifyOtp();
  const forgotPasswordMutation = useForgotPassword();

  const handleOTPChange = (value) => {
    setOtp(value);
    setError("");
  };

  const handleValidate = (e) => {
    e.preventDefault();
    setError("");
    if (!otp || otp.length !== 6) {
      setError("Please enter the 6-digit OTP.");
      return;
    }
    if (!phone_no) {
      setError("Phone number missing. Please restart the process.");
      return;
    }
    verifyOtpMutation.mutate(
      { phone_no, otp },
      {
        onSuccess: (res) => {
          if (res.status === "success" && res.token) {
            // Redirect to reset password page with token and phone_no
            navigate(
              `/reset-password?token=${res.token}&phone_no=${encodeURIComponent(
                phone_no
              )}`
            );
          } else if (res.status === "success" && res.reset_link) {
            navigate(res.reset_link); // fallback if backend returns reset_link
          } else {
            setError("Unexpected response. Please try again.");
          }
        },
        onError: (err) => {
          setError(
            err?.message ||
            err?.errors?.otp?.[0] ||
            "Invalid OTP. Please try again."
          );
        },
      }
    );
  };

  const handleReSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (!phone_no.trim()) {
      setError("Phone number is required");
      return;
    }
    // Optionally validate phone number format here
    // setIsLoading(true);
    forgotPasswordMutation.mutate(
      { phone_no },
      {
        onSuccess: (res) => {
          //   setIsLoading(false);
          if (res.status === "success") {
            navigate("/otp", { state: { phone_no } });
          } else {
            setError(res.message || "Something went wrong.");
          }
        },
        onError: (err) => {
          //   setIsLoading(false);
          const data = err?.response?.data || err;
          setError(
            (data?.errors?.phone_no &&
              Array.isArray(data.errors.phone_no) &&
              data.errors.phone_no[0]) ||
            data?.message ||
            "Failed to send reset link."
          );
        },
      }
    );
  };

  return (
    <>
      {/* login section start */}
      <section className="log-in-section section-b-space">
        <Link to="/" className="logo-login">
          <SafeImage
            src="assets/images/logo/1.png"
            className="img-fluid"
            alt="Logo"
          />
        </Link>
        <div className="container w-100">
          <div className="row">
            <div className="col-xl-5 col-lg-6 me-auto">
              <div className="log-in-box">
                <div className="log-in-title">
                  <h3 className="text-content">
                    Please enter the one time password to verify your account
                  </h3>
                  <h5 className="text-content">
                    A code has been sent to <span>{phone_no}</span>
                  </h5>
                </div>
                {error && (
                  <div className="alert alert-danger mt-2" role="alert">
                    {error}
                  </div>
                )}
                <div className="d-flex justify-content-center my-4">
                  <OTPInput length={6} onChangeOTP={handleOTPChange} />
                </div>
                <div className="send-box pt-4">
                  <h5>
                    Didn't get the code?
                    <button
                      className="theme-color fw-bold btn btn-link p-0"
                      type="button"
                      onClick={handleReSubmit}
                    >
                      Resend It
                    </button>
                  </h5>
                </div>
                <button
                  className="btn btn-animation w-100 mt-3"
                  type="submit"
                  onClick={handleValidate}
                  disabled={verifyOtpMutation.isLoading}
                >
                  {verifyOtpMutation.isLoading ? "Verify Otp..." : "Verify Otp"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* login section end */}
    </>
  );
}
